import Block from '@components/Layout/Block';
import { Minus, Plus } from '@components/MiscComponents';
import { DrawerHeader, Drawers } from '@components/PropertyDetailsComponents/Drawer/styles';
import { TabListing } from '@components/PropertyDetailsComponents/ListingHighlights';
import { ListingsContainer } from '@components/PropertyDetailsComponents/ListingHighlights/styles';
import { Collapse, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import { DevelopmentDrawerItem } from './mapData';

interface DevelopmentDrawerProps {
  drawers: DevelopmentDrawerItem[];
}

const DevelopmentDrawer: FC<DevelopmentDrawerProps> = ({ drawers }) => {
  const t = useTranslations();
  const [activeIndex, setActiveIndex] = useState<number | null>(0); // set first one open by default

  const handleItemClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Block narrow>
      <DrawerHeader>{t('Property Details')}</DrawerHeader>
      <Drawers>
        <List>
          {drawers?.map((drawer, index) => (
            <ListItem key={index}>
              <ListItemButton disableRipple onClick={() => handleItemClick(index)}>
                <ListItemText primary={drawer.header} />
                {activeIndex === index ? <Minus /> : <Plus />}
              </ListItemButton>

              <Collapse in={activeIndex === index}>
                {drawer.listings && (
                  <ListingsContainer>
                    {drawer.listings?.map((listing, index) => (
                      <TabListing
                        key={index}
                        header={listing.header}
                        content={listing.content?.[0]}
                      />
                    ))}
                  </ListingsContainer>
                )}
              </Collapse>
            </ListItem>
          ))}
        </List>
      </Drawers>
    </Block>
  );
};

export default DevelopmentDrawer;
